import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useQuery, useLazyQuery } from "@apollo/client";
import { useToast } from "@npm-telluria-tecnologia/telluria-ui";

/** Atoms */
import { SelectAllClient, LinkContractList } from "@atoms/index";

/** Molecules */
import { MessagesBox } from "@molecules/index";

/** Libraries */
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Zoom,
  TransitionProps,
  IconButton
} from "@libraries/mui";
import { Close } from "@libraries/icons";

// Language
import { ConcretingRequestMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";

/** Styled components */
import * as Styled from "./styles";

interface Props {
  open: boolean;
  onClose: () => void;
  concretingRequestId: string;
}

/** Transition helper component */
const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
  ) => <Zoom ref={ref} {...props} />
);

const MessagesDialog: React.FC<Props> = ({
  open,
  onClose,
  concretingRequestId
}) => {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Styled.Container
      open={open}
      onClose={handleClose}
      aria-labelledby="pendencyDialog-title"
      aria-describedby="pendencyDialog-description"
      TransitionComponent={Transition}
    >
      <DialogTitle id="pendencyDialog-title">
        {t(ConcretingRequestMessages.messagesDialogTitle)}
        <Styled.CustomIconButton aria-label="close" onClick={handleClose}>
          <Close />
        </Styled.CustomIconButton>
      </DialogTitle>
      <DialogContent>
        <MessagesBox concretingRequestId={concretingRequestId} />
      </DialogContent>
    </Styled.Container>
  );
};

export default MessagesDialog;
